import styled from "styled-components";
import Button from "@material-ui/core/Button";

export const StyledButton = styled(Button)`
  max-width: 275px;
  min-width: 100% !important;
  box-shadow: 0 1px 12px rgba(248, 154, 13, 0.3) !important;
  border-radius: 5px !important;

  span {
    color: #ffffff;
    font-family: "Lato";
    font-size: 18px;
    text-transform: initial;
  }
`;

export const ResetButton = styled.button`
  margin: 2px auto 0px;
  border: none;
  background: none;
  font-size: 18px;
  font-family: "Lato";
  cursor: pointer;
  color: #00add2;
  border-bottom: #ffffff solid 2px;
  display: block;

  @media only screen and (max-width: 599.95px) {
    display: inline-block;
  }

  &:focus {
    outline: none;
  }
  &:hover {
    border-bottom: #00add2 solid 2px;
  }
`;
